import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NumbersService } from '@shared/services/numbers.service';
import { ApiService } from '@shared/services/api.service';
import { SnackService } from '@shared/services/snack.service';

@Component({
	selector: 'app-campaign',
	templateUrl: './campaign.component.html',
	styleUrls: ['./campaign.component.scss'],
})
export class CampaignComponent implements OnInit {
	constructor(
		private router: Router,
		private title: Title,
		private numbers: NumbersService,
		private api: ApiService,
		private snack: SnackService,
		public locale: LocaleService
	) {}

	loading: boolean = true;
	categories = [];

	form: UntypedFormGroup = new UntypedFormGroup({
		name: new UntypedFormControl('', Validators.required),
		phone: new UntypedFormControl('', Validators.required),
		email: new UntypedFormControl('', [Validators.required, Validators.email]),
		category: new UntypedFormControl('', Validators.required),
		description: new UntypedFormControl('', Validators.required),
	});

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));
	}

	onSubmit() {
		this.loading = true;

		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('name', this.form['value']['name']);
		body.append('phone', this.form['value']['phone']);
		body.append('email', this.form['value']['email']);
		body.append('category', this.form['value']['category']);
		body.append('description', this.form['value']['description']);

		this.api.requestCampaign(body).subscribe(
			(res) => {
				if (res['status'] === '1') {
					this.snack.open(this.locale.translations['campaign']['s26']);
					this.router.navigate(['/'], {
						queryParams: {
							lang: this.locale.lang,
						},
					});
				} else {
					this.snack.open(this.locale.translations['misc']['n174']);
				}

				this.loading = false;
			},
			(err) => {
				console.error(err);
				this.snack.open(this.locale.translations['misc']['n174']);
				this.loading = false;
			}
		);
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['campaign']['n251'] + ' | ' + this.locale.translations['header']['n0']);

		// fetch categories
		const catFormData: FormData = new FormData();
		catFormData.append('lang', this.locale.lang);
		this.api.categories(catFormData).subscribe((res) => {
			this.categories = res['response'];
			this.loading = false;
		});
	}
}
